if (!customElements.get('container-hero-price')) {
  customElements.define('container-hero-price', class extends HTMLElement {
    connectedCallback() {
      this.row = this.querySelector('.container-hero-price__row');
      if (!this.row) return;

      this.availableWidth = 0;
      this.resizeObserver = new ResizeObserver(([entry]) => {
        const width = entry.contentRect.width;
        if (width === this.availableWidth) return;
        this.availableWidth = width;
        this.fitPrice();
      });
      this.resizeObserver.observe(this);
      document.fonts.ready.then(() => {
        if (this.isConnected) this.fitPrice();
      });
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    fitPrice() {
      if (!this.availableWidth) return;

      // Measure at the theme's fixed pixel sizes; shrink only when they overflow.
      this.row.style.removeProperty('--hero-price-scale');
      const width = this.row.getBoundingClientRect().width;
      if (width > this.availableWidth) {
        this.row.style.setProperty('--hero-price-scale', (this.availableWidth - 1) / width);
      }
    }
  });
}
